import { useLocation } from "react-router";

export function useReturnUrl() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const queryReturnUrl = searchParams.get("returnUrl");

    return queryReturnUrl || location.pathname + location.search;
}
